<template>
    <router-view></router-view>
  </template>
  
  <script>
      export default {
          name: "CrmHome"
      }
  </script>
  
  <style scoped>
  
  </style>
  